import { render } from "./vulnerability-fix.vue?vue&type=template&id=7ac3e214&scoped=true&ts=true"
import script from "./vulnerability-fix.vue?vue&type=script&lang=ts"
export * from "./vulnerability-fix.vue?vue&type=script&lang=ts"

import "./vulnerability-fix.vue?vue&type=style&index=0&id=7ac3e214&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac3e214"]])

export default __exports__